import React from "react";

import { Container } from "@mui/material";

export const Main: React.FC = () => {
  const [humbugs, setHumbugs] = React.useState(0);
  return <Container></Container>;
};
